import { defineComponent, watch } from 'vue';
import { PayRecordSearchVO } from "@/declares/vo/payCenter/PayRecordSearchVO";
import { payTypeEnum } from "@/declares/options/payCenter/payTypeOptions";
import vkbeautify from 'vkbeautify';
import X2js from 'x2js';
import { copyToClipBoard } from "@/support/util/util";
import { payRecordStatusEnum } from '@/declares/options/payCenter/payRecordStatusOptions';

const x2js = new X2js();


export class PayRecordParamsProps {
  model: PayRecordSearchVO = new PayRecordSearchVO();
}

function PayRecordParams(_props: any) {
  const props = _props as PayRecordParamsProps;

  return () => <div class="record-detail-card">
    <h5>业务端请求支付中心参数</h5>
    <json-viewer value={props.model.reqBody && props.model.reqBody.length ? JSON.parse(props.model.reqBody) : '{}'}
      copyable boxed sort />

    <h5>向第三方支付发送的请求体</h5>
    <div>
      {
        props.model.payType === payTypeEnum.wx ?
          <div>
            <json-viewer value={
              props.model.unifiedOrderReqBody && props.model.unifiedOrderReqBody.length ?
                (x2js.xml2js(props.model.unifiedOrderReqBody) as any).xml :
                {}
            } copyable boxed sort />
            <el-button type="text" onClick={() => copyToClipBoard(props.model.unifiedOrderReqBody, true)}>复制xml原文
            </el-button>
          </div>
          : null
      }
      {
        props.model.payType === payTypeEnum.alipay ?
          <div>
            <json-viewer value={
              props.model.unifiedOrderReqBody && props.model.unifiedOrderReqBody.length ?
                JSON.parse(props.model.unifiedOrderReqBody) :
                {}
            } copyable boxed sort />
          </div>
          : null
      }

      <h5>发起第三方支付后返回的参数</h5>
      {
        props.model.payType === payTypeEnum.wx ?
          <div>
            <json-viewer value={
              props.model.unifiedOrderResBody && props.model.unifiedOrderResBody.length ?
                (x2js.xml2js(props.model.unifiedOrderResBody) as any).xml :
                {}
            } copyable boxed sort />
            <el-button type="text" onClick={() => copyToClipBoard(props.model.unifiedOrderResBody, true)}>复制xml原文
            </el-button>
          </div>
          : null
      }
      {
        props.model.payType === payTypeEnum.alipay ?
          props.model.status === payRecordStatusEnum.startPayFail ?
            <div class="code">
              {props.model.unifiedOrderResBody}
            </div>
            :
            <div>
              <json-viewer value={
                props.model.unifiedOrderResBody && props.model.unifiedOrderResBody.length ?
                  JSON.parse(props.model.unifiedOrderResBody) :
                  {}
              } copyable boxed sort />
            </div>
          : null
      }


      <h5>第三方支付对支付中心回调的参数</h5>
      {
        props.model.payType === payTypeEnum.wx ?
          <div>
            <json-viewer value={
              props.model.notifyBody && props.model.notifyBody.length ?
                (x2js.xml2js(props.model.notifyBody) as any).xml :
                {}
            } copyable boxed sort />
            <el-button type="text" onClick={() => copyToClipBoard(props.model.notifyBody, true)}>复制xml原文
            </el-button>
          </div>
          : null
      }

    </div>
  </div>
}


export default defineComponent({
  props: {
    model: { type: Object, required: true },
  },
  setup: PayRecordParams
});
